import { ClothesShopCategoryIndex, IClothesShopItem } from '~/rage';
import { Gender } from '~/shared';
import { IListItem } from '../../components/ListTab';
import { createSlice } from '../wrappers';

export enum StageTypes {
	Category = 'category',
	List = 'list',
}

interface ClothesShopSlice {
	shopItems: IClothesShopItem[];
	ownedItems: IClothesShopItem[];
	wearingItems: string[];
	activeItemId: string;
	activeStage: StageTypes;
	activeCategory: ClothesShopCategoryIndex | null;
	maxCategoryIndex: number;
	activeList: IListItem[];
	activeListIndex: number | null;
	maxListIndex: number;
	tabIndex: number;
	maxTabIndex: number;
	inventoryEmpty: boolean;
	playerGender: Gender;
	searchValue: string;
}

const initialState: ClothesShopSlice = {
	shopItems: [],
	ownedItems: [],
	wearingItems: [],
	activeItemId: '',
	activeStage: StageTypes.Category,
	activeCategory: ClothesShopCategoryIndex.HAT,
	maxCategoryIndex: 0,
	activeList: [] as IListItem[],
	activeListIndex: null,
	maxListIndex: 0,
	tabIndex: 0,
	maxTabIndex: 1,
	inventoryEmpty: true,
	playerGender: Gender.MALE,
	searchValue: '',
};

const clothesShopSlice = createSlice({
	name: 'clothesShop',
	initialState,
	reducers: {
		setActiveStage: (state, action) => {
			state.activeStage = action.payload;
		},
		setActiveListIndex: (state, action) => {
			state.activeListIndex = action.payload;
		},
		setMaxListIndex: (state, action) => {
			state.maxListIndex = action.payload;
		},
		setActiveList: (state, action) => {
			state.activeList = action.payload;
		},
		setActiveCategory: (state, action) => {
			state.activeCategory = action.payload;
		},
		setMaxCategoryIndex: (state, action) => {
			state.maxCategoryIndex = action.payload;
		},
		setTabIndex: (state, action) => {
			state.tabIndex = action.payload;
		},
		setTabIndexPrev: (state) => {
			const index = state.tabIndex;
			state.tabIndex = index > 0 ? index - 1 : index;
		},
		setTabIndexNext: (state) => {
			const index = state.tabIndex;
			const maxIndex = state.maxTabIndex;
			state.tabIndex = index < maxIndex ? index + 1 : index;
		},
		setShopItems: (state, action) => {
			state.shopItems = action.payload;
		},
		setOwnedItems: (state, action) => {
			state.ownedItems = action.payload;
		},
		setWearingItems: (state, action) => {
			state.wearingItems = action.payload;
		},
		setActiveItemId: (state, action) => {
			state.activeItemId = action.payload;
		},
		setPlayerGender: (state, action) => {
			state.playerGender = action.payload;
		},
		setSearchValue: (state, action) => {
			state.searchValue = action.payload;
		},
	},
});

export const {
	setActiveStage,
	setActiveListIndex,
	setMaxListIndex,
	setActiveList,
	setActiveCategory,
	setMaxCategoryIndex,
	setTabIndex,
	setTabIndexPrev,
	setTabIndexNext,
	setShopItems,
	setOwnedItems,
	setWearingItems,
	setActiveItemId,
	setPlayerGender,
	setSearchValue,
} = clothesShopSlice.actions;

export default clothesShopSlice.reducer;
